import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

import { log } from "@/utils/log";

const SUPABASE_URL = "https://lxlkweksijlrliiauulx.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx4bGt3ZWtzaWpscmxpaWF1dWx4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3MzUyMzUzMTksImV4cCI6MjA1MDgxMTMxOX0.0y9aL06B6T2wc89NOS-YCaE6JIP_lK9yNPY_IpgXA-g";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_ANON_KEY,
  {
    auth: {
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
      storage: localStorage,
      storageKey: 'sb-lxlkweksijlrliiauulx-auth-token',
      flowType: 'pkce'
    },
    global: {
      headers: {
        'X-Client-Info': 'supabase-js-web'
      }
    }
  }
);

// Debug logging for session state
supabase.auth.onAuthStateChange((event, session) => {
  log.log('Auth state changed:', event, session?.user?.id);
  
  // Handle token refresh errors
  if (event === 'TOKEN_REFRESHED') {
    log.log('Token refreshed successfully');
  } else if (event === 'SIGNED_OUT') {
    log.log('User signed out - clearing session');
    localStorage.removeItem('sb-lxlkweksijlrliiauulx-auth-token');
  }
});

// Initialize session check
supabase.auth.getSession().then(({ data: { session }, error }) => {
  if (error) {
    log.error('Error checking session:', error);
    return;
  }
  log.log('Initial session check:', session?.user?.id);
});